import React from 'react';
import styles from './Stats.module.css';

const Stats = () => {
    return (
        <div className={styles["stats-container"]}>
            <div className={styles["stat-item"]}>
                <div className={styles["stat-content"]}>
                    <div className={styles["client-satisfaction"]} aria-hidden="true"></div>
                    <div className={styles["support-stats"]}> 
			<span className={styles["stat-number"]}>95%<h3>顧客満足度</h3></span>
			</div><br/>
			
                </div>
            </div>

            <div className={styles["stat-item"]}>
                <div className={styles["stat-content"]}>
                   <div className={styles["support-stats"]}>
                   <span className={styles["stat-number"]}>12年</span>
		</div>
		</div>
                   <div className={styles["support-stats"]}>
			 <span className={styles["stat-number"]}> <h3>保守運用実績</h3></span>
                </div>
            </div>

            <div className={styles["stat-item"]}>
                <div className={styles["stat-content"]}>
                    <div className={styles["support-stats"]}>
                        <span className={styles["stat-number"]}>24</span>
                        <span className={styles["stat-separator"]}></span>
                        <span className={styles["stat-number"]}><h3>時間</h3></span>
                        <span className={styles["stat-separator"]}></span>
                        <span className={styles["stat-number"]}>365 日 </span>
                    </div>
                   
                </div>
		  <div className={styles["support-stats"]}><h3>運用監視</h3></div>
            </div>
		

            <div className={styles["stat-item"]}>
		
                <div className={styles["stat-content"]}>
                   
			<div className={styles["support-stats"]}>
                   	<h3>27001<br/ >ISO 認証</h3>
		 <div className={styles["iso-certified"]} aria-hidden="true"></div>
		 </div>
		
                </div>

            </div>
        </div>
    );
};

export default Stats;